/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React from 'react';
import PropTypes from 'prop-types';
import { NavLink, generatePath } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useConfig } from 'app/hooks';
import { EntityContent } from 'app/components/Entity';
import FavoriteBtn from 'app/modules/cinemas/FavoriteBtn';
import SessionsDays from '../SessionsDays';
import { NoContent } from 'app/components';
import { useTranslation } from 'react-i18next';

const propTypes = {
  movieId: PropTypes.string.isRequired,
  cinemaSearchId: PropTypes.string.isRequired,
  sessions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          date: PropTypes.string.isRequired
        })
      )
    })
  ).isRequired,
  movieTitle: PropTypes.string.isRequired
};
const DailySessions = ({ movieId, sessions, isTrailerData, isgalleryData, cinemaSearchId, movieTitle, cinemas }) => {

  const isLoggedIn = !!useSelector(state => state.user.user);
  // const cinemas = useSelector(state => state.cinemas.cinemas);
  const { routes } = useConfig();
  const [t] = useTranslation();

  // for showing NoContent inside search filter section.
  const result = sessions.filter((ele) => {
    return ele.sessions.length;
  })
  return sessions && sessions.length
    ? sessions.map(session => {
      if (session?.sessions?.length && cinemas && cinemas.length) {
        if (cinemaSearchId) {
          if (cinemaSearchId === session?.id) {
            const items = session.sessions;
            const { id: cinemaId, cinemaUrlName: cinemaName, loyaltyCode, favorite } = cinemas.find(c => c?.id === session?.id);
            const LinkToCinema = () => (
              <NavLink
                className="b-entity-content__title b-entity-content__link"
                to={{ pathname: generatePath(routes.cinemaDetails.pattern, { id: cinemaName }) }}
              >
                {session.name}
              </NavLink>
            );

            return (
              <EntityContent key={cinemaId} isTrailerData={isTrailerData} isgalleryData={isgalleryData} isCinemaSession={true}>
                {isLoggedIn ? (
                  <div className="b-entity-content__link-wrapper">
                    <FavoriteBtn id={cinemaId} loyaltyCode={loyaltyCode} favorite={favorite} />
                    {LinkToCinema()}
                  </div>
                ) : (
                  LinkToCinema()
                )}
                {
                  movieTitle && cinemaId ? (
                    <SessionsDays
                      items={items}
                      movieId={movieId}
                      movieTitle={movieTitle}
                      cinemaId={cinemaId}
                      shownCount={6}
                    />) :
                    null}
              </EntityContent>
            )
          }
          else {

            return (

              result?.length === 1 ?
                <NoContent svgId="no-tickets" text={t("movies.no_sessions")} />
                :
                null
              // <NoContent svgId="no-tickets" text={t("movies.no_sessions")} /> 
            )
          }
        }

        else {

          const items = session.sessions;

          const { id: cinemaId, cinemaUrlName: cinemaName, loyaltyCode, favorite } = cinemas.find(c => c.id === session?.id);
          const LinkToCinema = () => (
            <NavLink
              className="b-entity-content__title b-entity-content__link"
              to={{ pathname: generatePath(routes.cinemaDetails.pattern, { id: cinemaName }) }}
            >
              {session.name}
            </NavLink>
          );

          return (
            <EntityContent key={cinemaId} isTrailerData={isTrailerData} isgalleryData={isgalleryData} isCinemaSession={true}>
              {isLoggedIn ? (
                <div className="b-entity-content__link-wrapper">
                  <FavoriteBtn id={cinemaId} loyaltyCode={loyaltyCode} favorite={favorite} />
                  {LinkToCinema()}
                </div>
              ) : (
                LinkToCinema()
              )}
              {
                movieTitle && cinemaId ? (
                  <SessionsDays
                    items={items}
                    movieId={movieId}
                    movieTitle={movieTitle}
                    cinemaId={cinemaId}
                    shownCount={6}
                  />)
                  :
                  null
              }
            </EntityContent>
          )
        }
      }
    })
    : null;
};

DailySessions.propTypes = propTypes;

export default DailySessions;
